import '../styles/HomeStoryBehind.scss';
import {Row, Col} from 'react-simple-flex-grid';
import {useInView} from 'react-intersection-observer';
import {useNavigate} from "react-router-dom";

export const HomeStoryBehind = () => {
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.35
    });

    const fortuneTellerFirst = 'https://www.youtube.com/watch?v=SIE2IdBquWU&list=PL0jiIBuf0E6u6kwTdENd1kvPGz5zjBMT7&index=20&ab_channel=SoftServe'
    const fortuneTellerSecond = 'https://www.youtube.com/watch?v=gbUxgw37qPU'

    const openVideo = (link: string) => {
        window.open(link, '_blank')
    }

    const navigate = useNavigate();

    return <>
        <div ref={ref} className={inView ? 'story-behind-wrapper slideInUp' : 'story-behind-wrapper'}>
            <div className="section-shadow section-shadow-from-top"></div>
            <div className="section-header">
                <h2 className="block-title">story behind Alnair</h2>
            </div>
            <div className="video-blocks-container">
                <Row align="bottom">
                    <Col xs={12} sm={6}>
                        <div className="video-block">
                            <div className="video-block-thumb thumb_1"></div>
                            <div className="video-block-footer">
                                <div className="footer-actions">
                                    <div className="footer-action" onClick={() => openVideo(fortuneTellerFirst)}>
                                        <h5 className="footer-title">Watch demo in action</h5>
                                        <div className="play-button">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"
                                                 viewBox="0 0 40 40"
                                                 fill="none">
                                                <circle cx="20" cy="20" r="19.5" stroke="white"/>
                                                <path
                                                    d="M25.5 19.634C26.1667 20.0189 26.1667 20.9811 25.5 21.366L18.75 25.2631C18.0833 25.648 17.25 25.1669 17.25 24.3971L17.25 16.6029C17.25 15.8331 18.0833 15.352 18.75 15.7369L25.5 19.634Z"
                                                    fill="white"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} sm={6}>
                        <div className="video-block">
                            <div className="video-block-thumb thumb_2"></div>
                            <div className="video-block-footer">
                                <div className="footer-actions">
                                    <div className="footer-action" onClick={() => openVideo(fortuneTellerSecond)}>
                                        <h5 className="footer-title">Watch behind the scenes</h5>
                                        <div className="play-button">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"
                                                 viewBox="0 0 40 40"
                                                 fill="none">
                                                <circle cx="20" cy="20" r="19.5" stroke="white"/>
                                                <path
                                                    d="M25.5 19.634C26.1667 20.0189 26.1667 20.9811 25.5 21.366L18.75 25.2631C18.0833 25.648 17.25 25.1669 17.25 24.3971L17.25 16.6029C17.25 15.8331 18.0833 15.352 18.75 15.7369L25.5 19.634Z"
                                                    fill="white"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="cards-container">
                <Row gutter={40}>
                    <Col xs={12} sm={6}>
                        <div className="card" onClick={() => navigate('/contact-us')}>
                            <div className="card-title">
                                let’s create together
                            </div>
                            <p className="card-description">
                                Immersive experience as a way to engage the customers, create long lasting memories, and
                                connect
                                customer with the brand more strongly.
                            </p>
                            <div className="card-link">
                                <svg xmlns="http://www.w3.org/2000/svg" width="51" height="50" viewBox="0 0 51 50"
                                     fill="none">
                                    <path d="M0 2H49M49 2V48M49 2L4 48" stroke="#FDEEEE" strokeWidth="4"/>
                                </svg>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} sm={6}>
                        <div className="card" onClick={() => navigate('/technologies')}>
                            <div className="card-title">
                                Our expertise
                            </div>
                            <p className="card-description">
                                This solution showcases SoftServe new service as well as our expertise in the many tech
                                used to create it.
                            </p>
                            <div className="card-link">
                                <svg xmlns="http://www.w3.org/2000/svg" width="51" height="50" viewBox="0 0 51 50"
                                     fill="none">
                                    <path d="M0 2H49M49 2V48M49 2L4 48" stroke="#FDEEEE" strokeWidth="4"/>
                                </svg>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="section-shadow section-shadow-from-bottom"></div>
        </div>
    </>
}
